module.exports = __webpack_public_path__ + "static/media/2.33a79594.jpg";